import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { BE_API_AUTH_URL } from '../constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AdminSupportCenterService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getSupportRequests(filters: { type?: string; status?: string } = {}): Observable<any[]> {
    let params = new HttpParams();
    if (filters.type) {
      params = params.set('type', filters.type);
    }
    if (filters.status) {
      params = params.set('status', filters.status);
    }

    return this.http
      .get<any[]>(`${BE_API_AUTH_URL}/support/request`, {
        headers: this.authService.createAuthorizationHeader(),
        params
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getSupportRequest(id: string): Observable<any> {
    return this.http
      .get<any>(`${BE_API_AUTH_URL}/support/request/${id}`, {
        headers: this.authService.createAuthorizationHeader()
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateSupportRequestStatus(id: string, status: string): Observable<any> {
    return this.http
      .patch<any>(`${BE_API_AUTH_URL}/support/request/${id}/status`, { status }, {
        headers: this.authService.createAuthorizationHeader()
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getAiInteractions(filters: { feedback?: string } = {}): Observable<any[]> {
    let params = new HttpParams();
    if (filters.feedback) {
      params = params.set('feedback', filters.feedback);
    }

    return this.http
      .get<any[]>(`${BE_API_AUTH_URL}/ai-interactions`, {
        headers: this.authService.createAuthorizationHeader(),
        params
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getAiInteraction(id: string): Observable<any> {
    return this.http
      .get<any>(`${BE_API_AUTH_URL}/ai-interactions/${id}`, {
        headers: this.authService.createAuthorizationHeader()
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
